import { Injectable, inject } from '@angular/core';
import { APP_CONFIG } from './app.config';

@Injectable({ providedIn: 'root' })
export class DatabaseConfigService {
  private config = inject(APP_CONFIG);

  get punkteDbName(): string {
    const prefix = this.config.isProduction ? '' : 'dev-';
    return `${prefix}${this.config.appName}-punkte`;
  }

  get projekteDbName(): string {
    const prefix = this.config.isProduction ? '' : 'dev-';
    return `${prefix}${this.config.appName}-projekte`;
  }

  get isDevelopment(): boolean {
    return !this.config.isProduction;
  }
}
